
import { defineComponent } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'
import Alert from '@/common/components/UI/Alert/index.vue'

export default defineComponent({
    components: {
        'the-button': TheButton,
        alert: Alert,
    },
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        created: {
            type: Boolean,
            default: false,
        },
        isFtl: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['submit', 'new-order'],
    setup(props, { emit }) {
        const emitSubmit = () => {
            if (props.loading) return
            emit('submit')
        }

        const emitNewOrder = () => {
            emit('new-order')
        }

        return { emitSubmit, emitNewOrder }
    },
})
